import { useMutation } from "@tanstack/react-query";

import medicalReviewApi from "@/services/medicalReviewApi";
import { downloadService } from "@/services/downloadService";
import { useAppNotification } from "@/hooks/useAppNotification";

/**
 * Download one version's uploaded plan document.
 *
 * The content endpoint is bearer-authenticated, so this goes through the shared
 * token-carrying fetch rather than a plain link, which would arrive
 * unauthenticated.
 */
export function useMonitoringPlanDownload(trialId: string) {
  const { openErrorNotification, contextHolder } = useAppNotification();

  const mutation = useMutation({
    mutationFn: ({
      version,
      filename,
    }: {
      version: number;
      filename: string;
    }) =>
      downloadService.downloadFileFromUrl(
        medicalReviewApi.planContentUrl(trialId, version),
        filename || `monitoring-plan-v${version}`,
      ),
    onError: () =>
      openErrorNotification({
        title: "Could not open the plan document",
        description: "The file could not be retrieved from storage.",
      }),
  });

  return {
    download: mutation.mutate,
    downloading: mutation.isPending,
    downloadingVersion: mutation.isPending ? mutation.variables?.version : null,
    contextHolder,
  };
}
